import { Box, TableCell } from "@mui/material";
import StyledTableRow from "../../../components/table/styled-table-row";
import { MemberPayment, MemberPaymentRequest } from "../../../service/model/member-payment.model";
import { useState } from "react";
import MemberPaymentForm from "./member-payment-form";
import { ConfirmationDialog } from "../../../components/confiramation-dialog";
import { useAppDispatch } from "../../../app/hooks";
import { deleteMemberPayment, updateMemberPayment } from "../member-payment.slice";
import useMemberships from "../../../hooks/use-memberships";
import TableActionButton from "../../../components/table/table-action-button";
import { EditIcon, DeleteIcon } from "../../../shared/icons";

interface TableRowProps {
    readonly payment: MemberPayment
}

const MemberPaymentTableRow: React.FC<TableRowProps> = ({ payment }) => {
    const dispatch = useAppDispatch();
    const [memberships] = useMemberships();
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [showMemberPaymentForm, setShowMemberPaymentForm] = useState(false);

    const handleDelete = () => {
        dispatch(deleteMemberPayment(payment.id))
        setShowDeleteDialog(false)
    }

    const handleDeleteCancel = () => {
        setShowDeleteDialog(false)
    }

    const handleSubmit = (data: MemberPaymentRequest) => {
        dispatch(updateMemberPayment({ ...data, id: payment.id, memberId: payment.memberId })).then(resp => {
            if (resp.meta.requestStatus === 'fulfilled') {
                setShowMemberPaymentForm(false);
            }
        });
    };

    return (
        <>
            <StyledTableRow key={payment.id}>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Member</Box>{`${payment.firstName} ${payment.lastName}`}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Amount</Box>{payment.amount}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Category</Box>{payment.category}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Payment Date</Box>{payment.paymentDate}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">From Date</Box>{payment.fromDate}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Membership</Box>{memberships.find(membership => membership.id === payment.membershipId)?.name}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Marked By</Box>{payment.markedByUser}</TableCell>
                {/* <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Expiry</Box>{node.branch.createdDate}</TableCell> */}
                <TableCell>
                    <Box component="div" display="inline" className="responsive-mobile-heading">Actions</Box>
                    {/* <IconButton onClick={() => setShowMemberPaymentForm(true)} sx={{color: `${theme.palette.secondary.main}`, paddingLeft: 0}}><VisibilityIcon /></IconButton> */}
                    <TableActionButton onClick={() => setShowMemberPaymentForm(true)} label="Edit" icon={<EditIcon />} />
                    <TableActionButton onClick={() => setShowDeleteDialog(true)} label="Delete" icon={<DeleteIcon />} />
                    {/* <Link className="btn" to="#" data-toggle="modal" data-target="#delete-member-modal" onClick={() => setShowDeleteDialog(true)}><DeleteIcon /></Link> */}
                </TableCell>
            </StyledTableRow>
            {showMemberPaymentForm &&
                <MemberPaymentForm payment={payment} editable={true} onClose={() => setShowMemberPaymentForm(false)} onSubmit={handleSubmit} />
            }
            {showDeleteDialog &&
                <ConfirmationDialog show={true} message="Are you sure you want to delete?" onConfirm={handleDelete} onCancel={handleDeleteCancel} />
            }
        </>
    );
}

export default MemberPaymentTableRow;